import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
    firebaseConnect,
    isEmpty,
    isLoaded,
} from "react-redux-firebase";
import { compose } from "redux";
import {
    Button,
    Container,
    Menu,
} from "semantic-ui-react";
import LoadingSegment from "./util/LoadingSegment";

function wrap(kids) {
    return <div>
        <Menu inverted className="smash-to-top" />
        <Container>
            {kids}
        </Container>
    </div>
}

function loading(text) {
    return wrap(<LoadingSegment text={text} />);
}

function LoginValve({ auth, authError, profile, firebase, children }) {
    if (!isLoaded(auth)) {
        return loading("Loading...");
    }

    if (isEmpty(auth)) {
        return wrap(<div>
            <h1>Hey! Sign in!</h1>
            <Button primary
                    onClick={() => firebase.login({ provider: "google" })}>
                Sign In w/ Google
            </Button>
            {!isEmpty(authError) && <div>
                <hr />
                {JSON.stringify(authError)}
            </div>}
        </div>);
    }

    if (!isLoaded(profile)) {
        return loading("Loading profile...");
    }

    return children;
}

LoginValve.propTypes = {
    firebase: PropTypes.shape({
        login: PropTypes.func.isRequired,
    }),
};

export default compose(
    firebaseConnect(),
    connect(({
                 firebase: {
                     auth,
                     profile,
                     authError,
                 },
             }) => ({
        auth,
        profile,
        authError,
    })),
)(LoginValve);



// WEBPACK FOOTER //
// ./src/LoginValve.js